<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Canceladas</h2>
    </div>

    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Solicitação" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Razão Social" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="De *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="De *" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="Até *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Até *" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <div class="tds-row" style="padding-right: 20px;">
                <a>Limitar resultado?</a>
                </div>
                <div class="tds-row">
                    <tds-radio-button name=”my-radio-button” value=”radio-value”> 
                    </tds-radio-button> Sim
                    <tds-radio-button name=”my-radio-button” value=”radio-value” style="padding-left: 10px;"> 
                    </tds-radio-button> Não
                </div>
            </div>

            <div class="tds-row" style="padding-top: 20px; justify-content: center">
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
                <tds-button type="button" variant="secondary" size="lg" text="Limpar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>
        </tds-accordion-item>

        <!-- Tabela -->
        <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-header>
                        <tds-header-cell cell-key='coD_ORIGINAL' cell-value='#' sortable></tds-header-cell>
                        <tds-header-cell cell-key='ref' cell-value='Ref' sortable></tds-header-cell>
                        <tds-header-cell cell-key='cliente' cell-value='Cliente' sortable></tds-header-cell>
                        <tds-header-cell cell-key='cnpjCpf' cell-value='CNPJ/CPF' sortable></tds-header-cell>
                        <tds-header-cell cell-key='inicio' cell-value='Início' sortable></tds-header-cell>
                        <tds-header-cell cell-key='previsao' cell-value='Previsão' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dealer' cell-value='Dealer' sortable></tds-header-cell>
                        <tds-header-cell cell-key='fOffice' cell-value='F-Office' sortable></tds-header-cell>
                        <tds-header-cell cell-key='produto' cell-value='Produto' sortable></tds-header-cell>
                        <tds-header-cell cell-key='modalidade' cell-value='Modalidade' sortable></tds-header-cell>
                        <tds-header-cell cell-key='quantidade' cell-value='Quantidade' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="coD_ORIGINAL">883407</tds-body-cell>
                            <tds-body-cell cell-key="ref">24/87</tds-body-cell>
                            <tds-body-cell cell-key="cliente">BAUMINAS LOG E TRANSPORTE S/A</tds-body-cell>
                            <tds-body-cell cell-key="cnpjCpf">144297950000162</tds-body-cell>
                            <tds-body-cell cell-key="inicio">11/10/2024</tds-body-cell>
                            <tds-body-cell cell-key="previsao">04/01/2025</tds-body-cell>
                            <tds-body-cell cell-key="dealer">COVEPE MURIAE (49)</tds-body-cell>
                            <tds-body-cell cell-key="fOffice">-</tds-body-cell>
                            <tds-body-cell cell-key="produto">R 450 A6X2 E6</tds-body-cell>
                            <tds-body-cell cell-key="modalidade">A VISTA</tds-body-cell>
                            <tds-body-cell cell-key="quantidade">7</tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
        </tds-accordion-item>
    </tds-accordion>
</div>